// Same checks as the Ez-RPH app and submitContactMessage: E.164; a
// Malaysian number must be a mobile of the right length for its prefix
// (011: 8 digits after it; 015, 018, 019: 7 or 8; the rest: 7).
export const normalizePhone = (raw: string): string | null => {
  let p = raw.replace(/[\s\-().]/g, '');
  if (p.startsWith('+')) {
    // keep
  } else if (p.startsWith('00')) {
    p = '+' + p.slice(2);
  } else if (p.startsWith('60')) {
    p = '+' + p;
  } else if (p.startsWith('0')) {
    p = '+60' + p.slice(1);
  } else {
    return null;
  }
  // "+60 012-345 6789": the local 0 kept after the country code.
  if (p.startsWith('+600')) p = '+60' + p.slice(4);
  if (!/^\+[1-9]\d{7,14}$/.test(p)) return null;
  if (p.startsWith('+60') && !/^\+601(?:[023467]\d{7}|1\d{8}|[589]\d{7,8})$/.test(p)) {
    return null;
  }
  return p;
};

// A Malaysian mobile whose digits after the prefix are one digit over and
// over (011-1111 1111) or a straight run (012-345 6789).
export const looksMadeUpPhone = (e164: string): boolean => {
  if (!e164.startsWith('+601')) return false;
  const d = e164.slice(5).split('').map(Number);
  const every = (step: number) => d.every((x, i) => i === 0 || x - d[i - 1] === step);
  return every(0) || every(1) || every(-1);
};
